import { render, staticRenderFns } from "./GeoDataRevision.vue?vue&type=template&id=c894d248&"
import script from "./GeoDataRevision.vue?vue&type=script&lang=js&"
export * from "./GeoDataRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports